const ContactPage = () => {
  return (
    <>
      <div className="tinas-section bg-2">
        <div style={{ padding: 80 }}></div>
        <img
          className="tinas-section-img"
          src="https://i.ibb.co/TrWmNQK/IMG-0977.jpg"
        />
        <div className="tinas-section-text">a legemd.</div>
      </div>
      <div className="tinas-section bg-1">
        <div style={{ padding: 40 }}></div>
        <img
          className="tinas-section-img"
          src="https://i.ibb.co/YW3VTRy/IMG-1098.jpg"
        />
        <div className="tinas-section-text">a goof.</div>
      </div>
      <div className="tinas-section bg-2">
        <div style={{ padding: 40 }}></div>
        <img
          className="tinas-section-img"
          src="https://i.ibb.co/xqtn61P/IMG-0261.jpg"
        />
        <div className="tinas-section-text">a squimshy baby.</div>
      </div>
    </>
  );
};

export default ContactPage;
